import Jumbotron from './Jumbotron';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
const SingleBlog =()=> {
    const { id } = useParams(); // Get the blog ID from the URL
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBlog = async () => {
        try {
            const token = localStorage.getItem("token");

          setLoading(true);
          const response = await axios.get(
            `https://azebrahimi.eastus.cloudapp.azure.com/api/Blog/GetBlog/${id}`,{
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Include the token here
                },
            }
          ); // Replace with your API endpoint
          setBlog(response.data);
        } catch (err) {
          console.error("Error fetching blog:", err);
          setError("Failed to fetch blog. Please try again later.");
        } finally {
          setLoading(false);
        }
      };
      useEffect(() => {
        fetchBlog();
      }, [id]);
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        // Get hours, minutes, and seconds
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        // Determine AM/PM
        const period = hours >= 12 ? 'PM' : 'AM';
        // Convert to 12-hour format
        hours = hours % 12 || 12; // If hours is 0 (midnight), convert to 12
        // Format hours with leading zero
        hours = String(hours).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${period}`;
      };
      
      if (loading) return <h4 className='text-center'>Loading please wait...</h4>;
      if (error) return <h4 className='text-center'>Error: {error}</h4>;
    return ( 
        <>
         <Jumbotron />
         <div className="page-padd mt-4">
         {blog ? (
        <>
            <div className="social-buttons" data-aos="fade-up" data-aos-duration="700">
                <div className="row">
                    <div className="col-sm-5 col-md-6">
                        <div className="inner-text">
                            <h3>{formatDate(blog.createdOn)} Posted by <span style={{fontWeight:"bold"}}>{blog.createdBy}</span></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" data-aos="fade-up" data-aos-duration="700">
                <div className="col-sm-12 col-lg-12 box">
                    <h2>{blog.title}</h2>
                    <p dangerouslySetInnerHTML={{__html: blog.description}}></p>
                    {/* <p>Welcome to my personal travel blog, i love to travel the globe, i have been to so <a href="blog_single.html">many beautiful</a> places and met interesting people around the world, this website is my mirror of life. </p>
                    <p>Welcome nal travel blog, i love to travel the globe, i have been to so many beautiful Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interes Welcom y personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interesting people around the world, this website is my mirror of life. </p>
                    <p>Welcome to my personal travel blog, i love to travel the globe, i </p>
                    <p>Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interesting people around the world, this website is my mirror of life. </p>
                    <p>Welcome nal travel blog, i love to travel the globe, i have been to so <a href="blog_single.html">many beautiful</a> Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interes Welcom y personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interesting people around the world, this website is my mirror of life. </p>
                    <p>Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful...e world, this website is my mirror of life. </p>
                    <p>Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interesting people around the world, this website is my mirror of life.</p>
                    <p>Welcome nal travel blog, i love to travel the globe, i have been to so <a href="blog_single.html">many beautiful</a> Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interes Welcom y personal travel blog, i love to travel the globe, i have been to so many beautiful places and met interesting people around the world, this website is my mirror of life. </p>
                    <p>Welcome to my personal travel blog, i love to travel the globe, i have been to so many beautiful...e world, this website is my mirror of life. </p> */}
                </div>
            </div>
            </>
      ) : (
        <h4 className='text-center'>No blogs found.</h4>
      )}
       </div> 
       </>
       )
}

export default SingleBlog;